(function (angular) {
    angular
        .module('one.admin')
        .controller('AddNewsModuleModalController', AddNewsModuleModalController);

    AddNewsModuleModalController.$inject = ['$scope', '$uibModalInstance', 'session','ModuleService', 'params'];

    function AddNewsModuleModalController($scope, $uibModalInstance, session, ModuleService, params) {
        $scope.module = {
            module_instance: { }
        };

        angular.merge($scope, params);

        $scope.addNewsModule = addNewsModule;
        $scope.cancel = cancel;

        function addNewsModule(data) {
            ModuleService.addModule(data).then(function (data) {
                $uibModalInstance.close(data);
            });
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})(angular);
